import {Loader} from "@/src/modules/core/components";

import {useLogout} from "../hooks";

export default function LogoutPage() {
  useLogout();

  return <Loader className="h-screen" />;
}
